import "../css/ThreeColumnsCards.css";
import { Row, Col, Button, Flex } from 'antd';
import { useQuery } from "@apollo/client";
import { GET_THREE_COLUMNS_CARDS } from "../queries";
import { useState } from "react";
import { getFromLocalStorage, saveToLocalStorage } from "../utils/localStorage";
import parseCarousellData from '../utils/parseCarousellData'
import { LargeCard, SmallCard } from "./Cards";
import setImageAbsoluteUrl from "../utils/setImageAbosulteUrl";
import useIsMobile from "../utils/isMobile";

const CardType = ({ title, description, mediaItemUrl, imageName, type, center = false }) => {
  if (type === 'smallCards') {
    return (
      <>
        <SmallCard title={title} description={description} image={mediaItemUrl} center={center}/>
      </>
    )
  } else if (type === 'largeCards') {
    return (
      <>
        <LargeCard title={title} description={description} mediaItemUrl={mediaItemUrl} altText={imageName}/>
      </>
    )
  }
}

const ThreeColumnsCards = ({ page, section, type, lang, center = false }) => {
  const isMobile = useIsMobile();
  const slug = `${page}-${section}-${lang}`;
  const [sectionData, setSectionData] = useState(() => {
    const cachedData = getFromLocalStorage(page);
    return cachedData?.sections?.[slug] || null;
  });

  const { loading, error } = useQuery(GET_THREE_COLUMNS_CARDS, {
    variables: { slug },
    skip: !!sectionData,
    onCompleted: (fetchedData) => {
      const postData = {
        titulo: fetchedData.sectionsBy?.threecolumnscards?.titulo,
        link: fetchedData.sectionsBy?.threecolumnscards?.link,
        images: parseCarousellData(fetchedData.sectionsBy?.threecolumnscards.images)
      }      
      const dataToLocal = {
        ...sectionData,
        sections: {
          [slug]: postData,
        },
      }
      saveToLocalStorage(page, dataToLocal);
      setSectionData(postData);
    },
  });

  return (
    <>
    {
      sectionData && (
        <Flex className="ThreeColumnsCards" vertical>
          <Flex className="ThreeColumnsCards-title">
            <Flex>
              <h2
                className="h4-headline-500"
                dangerouslySetInnerHTML={{ __html: sectionData?.titulo }}
              />
            </Flex>
            {sectionData?.link && (
              <Button 
                className="bt-medium-500" 
                style={{color: '#0027F9' }} 
                type="link" 
                href={sectionData?.link?.url} 
                variant="link">
                  {sectionData?.link?.title}
              </Button>
            )}
          </Flex>
          {sectionData?.images.reduce((acc, image, index) => {
            if (index % 3 === 0) acc.push([]);
            acc[acc.length - 1].push(image);
            return acc;
          }, []).map((row, rowIndex) => (
            <Row gutter={[32]} justify="center" style={{ width: '100%', marginBottom: '32px', justifyContent: 'start' }} key={rowIndex}>
              {row.map((image, colIndex) => (
                <Col span={8} key={colIndex}>
                  <CardType 
                    title={image.title} 
                    description={image.content} 
                    mediaItemUrl={setImageAbsoluteUrl(image.mediaItemUrl)} 
                    imageName={image.imageName} 
                    type={type} 
                    center={center}
                  />
                </Col>
              ))}
            </Row>
          ))}
        </Flex>
      )
    }
    </>
  );
};

export default ThreeColumnsCards;
